<template>
  <div class="freshdesk-container">
    <public-header :show-logo="true" />
    <div class="dashboard-content">
      <loader :height="500" />
    </div>
  </div>
</template>
<script>
import PublicHeader from '@/components/PublicHeader'
import Loader from '@/components/common/Loader/'
import accountsService from '@/services/accounts'

export default {
  created() {
    this.freshDeskLogin()
  },
  mounted() {
    this.$mpTrack('Freshdesk page mounted')
  },
  methods: {
    async freshDeskLogin() {
      const { fullPath } = this.$route
      const res = await accountsService.addFreshDeskURL({
        vars: {
          url: process.env.VUE_APP_DRIP_WEB_HOST + fullPath
        }
      })
      if (res.data) {
        const a = document.createElement('a')
        a.href = res.data
        a.click()
      }
    }
  },
  components: {
    PublicHeader,
    Loader
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables';

.freshdesk-container {
  @include gradient-radial(#f8f8f8, #eee);
  @media screen {
    height: 100vh;
    overflow: auto;
  }
  flex-grow: 1;
  padding-left: 30px;
  padding-right: 30px;
}
.dashboard-content {
  max-width: 1200px;
  padding: 0 30px;
  margin: 0 auto;
  height: calc(100vh - 140px);
}
</style>
